import { isMobileView, scrollIntoView } from "/Assets/js/common/utilities.js";

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-sticky-element]")) {
        const sticky = new StickyElement();
        sticky.init();
    }
});

export default class StickyElement {
    constructor() {
        this.initializeMobileStickyNav();
    }

    init() {
        if (this.isStickySupported() && !isMobileView()) {
            const stickyElement = document.querySelector("[data-sticky-element]");
            const stickyParent = stickyElement.parentElement;
            const ctaElement = document.querySelector(".sticky-nav-cta");

            const sentinel = document.createElement("div");
            sentinel.style.height = "0px";
            stickyParent.insertBefore(sentinel, stickyElement);

            const observer = new IntersectionObserver(
                ([entry]) => {
                    const isStuck = !entry.isIntersecting;
                    stickyElement.classList.toggle("is-stuck", isStuck);

                    if (ctaElement) {
                        if (isStuck) {
                            ctaElement.classList.remove("hide-element");
                        } else {
                            ctaElement.classList.add("hide-element");
                        }
                    }
                },
                { threshold: [0], rootMargin: "-1px 0px 0px 0px" }
            );

            observer.observe(sentinel);
        }
        this.setupStickyNavLinks();
    }

    isStickySupported() {
        return CSS.supports && CSS.supports("position", "sticky");
    }

    initializeMobileStickyNav() {
        const self = this;
        const menuElement = document.querySelector(".sticky-nav-menu");

        // Safely exit if the mobile sticky nav menu is not present on the page
        if (!menuElement) {
            return;
        }

        menuElement.addEventListener("click", function () {
            const linksElement = document.querySelector(".sticky-nav-links-mobile");

            // If links element is missing, do nothing
            if (!linksElement) {
                return;
            }

            const isHidden =
                linksElement.style.display === "none" ||
                getComputedStyle(linksElement).display === "none";

            if (isHidden) {
                self.slideDown(linksElement, 600, () => self.updateMenuIcon(false));
            } else {
                self.slideUp(linksElement, 600, () => self.updateMenuIcon(true));
            }
        });
    }

    setupStickyNavLinks() {
        // Find all elements with data-product-nav-link attribute
        const navLinks = document.querySelectorAll("[data-product-nav-link]");

        // Add click event listener to each link
        navLinks.forEach(link => {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                const target = this.getAttribute("href");

                // Update URL without page reload
                if (history.pushState) {
                    history.pushState(null, null, target); // use history.pushState if possible to prevent anchor jumping
                } else {
                    location.hash = target;
                }

                // Scroll to target element if defined
                if (target !== undefined) {
                    // Remove the # character from the beginning of the target
                    const targetId = target.startsWith("#") ? target.substring(1) : target;
                    // Find element by ID
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        // Use 75px offset for non-mobile views
                        scrollIntoView(targetElement, { behavior: "smooth" }, 75);
                    }
                }
            });
        });
    }

    slideDown(element, duration, callback) {
        // Set initial state
        element.style.display = "block";
        element.style.height = "0px";
        element.style.overflow = "hidden";
        element.style.transition = `height ${duration}ms cubic-bezier(0.25, 0.1, 0.25, 1)`;
        element.style.opacity = "0";
        element.style.transition = `height ${duration}ms cubic-bezier(0.25, 0.1, 0.25, 1), opacity ${duration * 0.8}ms ease`;

        // Force browser to recognize the element before animation
        const height = element.scrollHeight;

        requestAnimationFrame(() => {
            element.style.height = `${height}px`;
            element.style.opacity = "1";

            // Clean up after transition completes
            const onTransitionEnd = () => {
                element.style.height = "";
                element.style.overflow = "";
                element.style.transition = "";
                element.style.opacity = "";
                element.removeEventListener("transitionend", onTransitionEnd);
                if (callback) callback();
            };

            element.addEventListener("transitionend", onTransitionEnd, { once: true });
        });
    }

    slideUp(element, duration, callback) {
        // Set initial state
        element.style.height = `${element.offsetHeight}px`;
        element.style.overflow = "hidden";
        element.style.transition = `height ${duration}ms cubic-bezier(0.25, 0.1, 0.25, 1), opacity ${duration * 0.8}ms ease`;

        // Force browser to recognize the element before animation
        requestAnimationFrame(() => {
            element.style.height = "0px";
            element.style.opacity = "0";

            // Clean up after transition completes
            const onTransitionEnd = () => {
                element.style.display = "none";
                element.style.height = "";
                element.style.overflow = "";
                element.style.transition = ("");
                element.style.opacity = "";
                element.removeEventListener("transitionend", onTransitionEnd);
                if (callback) callback();
            };

            element.addEventListener("transitionend", onTransitionEnd, { once: true });
        });
    }

    updateMenuIcon(isHidden) {
        const menuElement = document.querySelector(".sticky-nav-menu");
        const iconElement = document.querySelector(".sticky-nav-menu-icon");

        if (isHidden) {
            menuElement.classList.remove("times");
            menuElement.classList.add("ellipsis");
            iconElement.innerHTML = "<svg aria-hidden=\"true\" focusable=\"false\"><use xlink: href=\"/dist/spritemap.svg#ellipsis-v\"></use></svg>";
        } else {
            menuElement.classList.remove("ellipsis");
            menuElement.classList.add("times");
            iconElement.innerHTML = "<svg aria-hidden=\"true\" focusable=\"false\"><use xlink: href=\"/dist/spritemap.svg#times\"></use></svg>";
        }
    }
}